<script>
  import { router } from "tinro";
  import { onMount } from "svelte";
  import { baseAPIUrl, APP_API_KEY } from "../globals";
  //import createApp from '@shopify/app-bridge';
  //import { Redirect } from '@shopify/app-bridge/actions';

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const hmac = urlParams.get("hmac");
  const shop = urlParams.get("shop");
  const session = urlParams.get("session");
  onMount(() => {
    if (hmac && session && shop) {
      router.goto("/");
    }
  });

  var AppBridge = window["app-bridge"];
  var createApp = AppBridge.createApp;
  var actions = AppBridge.actions;
  var Redirect = actions.Redirect;

  let host;
  const redirectUri = baseAPIUrl + "/generate";

  const install = () => {
    let permissionUrl =
      "https://" +
      host +
      "/admin" +
      "/oauth/authorize?client_id=" +
      APP_API_KEY +
      "&scope=read_products&redirect_uri=" +
      redirectUri +
      "&access=shopify";
    if (window.top == window.self) {
      window.location.assign(permissionUrl);
      // If the current window is the 'child', change the parent's URL with Shopify App Bridge's Redirect action
    } else {
      const app = createApp({
        apiKey: apiKey,
        host: host,
      });

      Redirect.create(app).dispatch(Redirect.Action.REMOTE, permissionUrl);
    }
  };
</script>

<div class="wrapper">
  <div class="container">
    <input type="text" bind:value={host} placeholder="ShopName.myshopify.com" />
    <div class="btn" on:click={install}>Install app</div>
  </div>
</div>

<style>
  * {
    padding: 0;
    margin: 0;
  }
  .wrapper {
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .container {
    background: white;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
    border-radius: 0.25rem;
    width: 380px;
    height: 150px;
    padding: 25px 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: black;
  }
  .container div {
    width: max-content;
    padding: 8px 12px;
    background-color: var(--primaryColor);
    cursor: pointer;
    border-radius: 0.25rem;
    color: black;
  }
  .container input {
    width: 90%;
    border-radius: 0.25rem;
  }
</style>
